import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { EffButtonComponent } from "../../eff-button/eff-button.component";
import { EffPopupHeaderComponent } from "../eff-popup-header/eff-popup-header.component";

@Component({
    selector: "eff-confirmation-popup",
    templateUrl: "./eff-confirmation-popup.component.html",
    styleUrls: ["./eff-confirmation-popup.component.scss"],
    imports: [EffButtonComponent, EffPopupHeaderComponent]
})
export class EffConfirmationPopupComponent {
    data = inject(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<EffConfirmationPopupComponent>>(MatDialogRef);


    get icon(): string {
        return this.data.confirmType == "warning-button" ? "warning" : "";
    }
}
